"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieServer = exports.CookieClient = exports.Cookie = void 0;

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.entries.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.string.starts-with.js");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseKey"));

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    (0, _classCallCheck2.default)(this, Cookie);
  }

  (0, _createClass2.default)(Cookie, [{
    key: "stringify",
    value: function stringify(name, value, options) {
      var key = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      return "".concat(key, "=").concat(Cookie.converter.write(value)).concat(Cookie.stringifyAttrs(options !== null && options !== void 0 ? options : {}));
    }
  }, {
    key: "parse",
    value: function parse(cookie) {
      if (cookie === '') {
        return {};
      }

      return cookie.split('; ').map(function (x) {
        return x.split('=');
      }).reduce(function (acc, _ref) {
        var _ref2 = (0, _toArray2.default)(_ref),
            key = _ref2[0],
            value = _ref2.slice(1);

        // @ts-ignore
        acc[Cookie.converter.read(key)] = Cookie.converter.read(value.join('='));
        return acc;
      }, {});
    }
  }]);
  return Cookie;
}();

exports.Cookie = Cookie;
Cookie.converter = {
  read: function read(value) {
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};

Cookie.stringifyAttrs = function (options) {
  var attrs = '';
  if (options.maxAge) attrs += "; max-age=".concat(options.maxAge);
  if (options.path) attrs += "; path=".concat(options.path);
  if (options.expires) attrs += "; expires=".concat(options.expires.toUTCString());
  if (options.domain) attrs += "; domain=".concat(options.domain);
  if (options.sameSite) attrs += "; samesite=".concat(options.sameSite);
  if (options.secure) attrs += '; secure';
  if (options.httpOnly) attrs += '; httponly';
  return attrs;
};

var _cookie = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("cookie");

var CookieClient = /*#__PURE__*/function () {
  function CookieClient() {
    (0, _classCallCheck2.default)(this, CookieClient);
    Object.defineProperty(this, _cookie, {
      writable: true,
      value: new Cookie()
    });
  }

  (0, _createClass2.default)(CookieClient, [{
    key: "get",
    value: function get() {
      return (0, _classPrivateFieldLooseBase2.default)(this, _cookie)[_cookie].parse(document.cookie);
    }
  }, {
    key: "set",
    value: function set(name, value, options) {
      document.cookie = (0, _classPrivateFieldLooseBase2.default)(this, _cookie)[_cookie].stringify(name, value, options);
    }
  }, {
    key: "remove",
    value: function remove(name) {
      this.set(name, '', {
        maxAge: -1
      });
    }
  }]);
  return CookieClient;
}();

exports.CookieClient = CookieClient;

var _res = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("res");

var _req = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("req");

var _cookie2 = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("cookie");

var CookieServer = /*#__PURE__*/function () {
  function CookieServer(_ref3) {
    var req = _ref3.req,
        res = _ref3.res;
    (0, _classCallCheck2.default)(this, CookieServer);
    Object.defineProperty(this, _res, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _req, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cookie2, {
      writable: true,
      value: new Cookie()
    });
    (0, _classPrivateFieldLooseBase2.default)(this, _req)[_req] = req;
    (0, _classPrivateFieldLooseBase2.default)(this, _res)[_res] = res;
  }

  (0, _createClass2.default)(CookieServer, [{
    key: "getHeaders",
    value: function getHeaders() {
      var _classPrivateFieldLoo;

      var resHeader = (_classPrivateFieldLoo = (0, _classPrivateFieldLooseBase2.default)(this, _res)[_res].getHeader('Set-Cookie')) !== null && _classPrivateFieldLoo !== void 0 ? _classPrivateFieldLoo : [];
      return Array.isArray(resHeader) ? (0, _toConsumableArray2.default)(resHeader) : [String(resHeader)];
    }
  }, {
    key: "get",
    value: function get() {
      var _classPrivateFieldLoo2;

      return _objectSpread(_objectSpread({}, (0, _classPrivateFieldLooseBase2.default)(this, _cookie2)[_cookie2].parse((_classPrivateFieldLoo2 = (0, _classPrivateFieldLooseBase2.default)(this, _req)[_req].headers.cookie) !== null && _classPrivateFieldLoo2 !== void 0 ? _classPrivateFieldLoo2 : '')), this.getHeaders().map((0, _classPrivateFieldLooseBase2.default)(this, _cookie2)[_cookie2].parse).reduce(function (acc, cookie) {
        var _Object$entries = Object.entries(cookie),
            _Object$entries2 = (0, _slicedToArray2.default)(_Object$entries, 1),
            _Object$entries2$ = _Object$entries2[0];

        _Object$entries2$ = _Object$entries2$ === void 0 ? [] : _Object$entries2$;

        var _Object$entries2$2 = (0, _slicedToArray2.default)(_Object$entries2$, 2),
            key = _Object$entries2$2[0],
            value = _Object$entries2$2[1];

        if (key === undefined) {
          return acc;
        }

        return _objectSpread(_objectSpread({}, acc), {}, {
          [key]: value
        });
      }, {}));
    }
  }, {
    key: "set",
    value: function set(name, value, options) {
      var headers = this.getHeaders().filter(function (header) {
        return !header.startsWith("".concat(name, "="));
      });
      headers.push((0, _classPrivateFieldLooseBase2.default)(this, _cookie2)[_cookie2].stringify(name, value, options));

      (0, _classPrivateFieldLooseBase2.default)(this, _res)[_res].setHeader('Set-Cookie', headers);
    }
  }, {
    key: "remove",
    value: function remove(name) {
      this.set(name, '', {
        maxAge: -1
      });
    }
  }]);
  return CookieServer;
}();

exports.CookieServer = CookieServer;